var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"profilelayout"},[(_vm.profile)?_c('div',[(_vm.profile.token)?_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("My Token")]),_vm._v(" : "),_c('b',[_vm._v(_vm._s(_vm.profile.token))])]):_vm._e(),_vm._v(" "),(_vm.profile.qr)?_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.profile.qr)}})]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c23e23c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 465
// module chunks = 1